import styled from 'styled-components'
import { Text, Flex, useTooltip, Button } from 'uikit'
import { getTokenUrl } from 'utils/getTokenUrl'
import { useWeb3React } from '@web3-react/core'
import { useHistory } from 'react-router-dom'
import CountUp from 'react-countup'
import BN from 'bignumber.js'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { Trans } from 'react-i18next'

interface GameCardProps {
  id: string
  title: string
  winRate: string
  multiple: number
  infoRight: string
  link: string
  infoLeft?: string
  showAmount?: number
}

const StyledGameCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  width: 384px;
  height: 421px;
  padding: 16px;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`

const StyleBg = styled.div<{ url: string }>`
  background: url(${({ url }) => url}) no-repeat;
  background-size: cover;
  width: 352px;
  height: 200px;
  border-radius: 20px;
  padding: 14px;
  @media (max-width: 768px) {
    width: 100%;
    height: 182px;
  }
`

const AmountTag = styled(Flex)`
  height: 24px;
  border-radius: 16px;
  background: white;
  padding: 0 6px 0 2px;
  justify-content: space-between;
  align-items: center;
`

const ImgToken = styled.img`
width: 20px;
height: 20px;
border-radius: 10px;
margin-right: 4p;x
`

const ImgInfo = styled.img`
  width: 14px;
  height: 14px;
`

const StyledInfo = styled(Flex)`
  width: 24px;
  height: 24px;
  border-radius: 16px;
  background: white;
  justify-content: center;
  align-items: center;
`

const StyledMultipleTag = styled(Flex)`
  background: rgba(20, 216, 157, 0.1);
  border-radius: 12px;
  height: 24px;
  align-items: center;
  padding: 0 7px;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  margin-left: 8px;
`

const NumberText = styled.span`
  color: #fc9c47;
  font-size: 16px;
  font-weight: 700;
`

const MultipleText = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #14d89d;
  line-height: 18px;
`

interface AmountCardProps {
  amount: number
  info: string
}

const Imgs = {
  'card-img-lottery': require('assets/images/home/lottery.webp').default,
  'card-img-prediction': require('assets/images/home/prediction.webp').default,
  info: require('assets/images/prediction/info.svg').default,
}

const AmountCard: React.FC<AmountCardProps> = ({ amount, info }) => {
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text>{info}</Text>
    </>,
    { placement: 'top' }
  )
  return (
    <AmountTag ref={targetRef}>
      {tooltipVisible && tooltip}
      <Flex alignItems="center">
        <ImgToken src={getTokenUrl('MJT')} />
        <Text fontSize="14px" mr="3px" ml="3px">
          {/* @ts-ignore */}
          <CountUp end={amount} decimals={0} duration={1} separator="," />
        </Text>
        <ImgInfo src={Imgs.info} />
      </Flex>
    </AmountTag>
  )
}

const GameCard: React.FC<GameCardProps> = ({ id, title, link, showAmount, infoLeft, infoRight, multiple, winRate }) => {
  const { account } = useWeb3React()
  const history = useHistory()

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text>{infoRight}</Text>
    </>,
    { placement: 'top' }
  )

  return (
    <StyledGameCard>
      <StyleBg url={Imgs[id]}>
        <Flex justifyContent="space-between" alignItems="center">
          {showAmount ? <AmountCard amount={showAmount} info={infoLeft} /> : <div />}
          <StyledInfo ref={targetRef}>
            <ImgInfo src={Imgs.info} />
          </StyledInfo>
        </Flex>
      </StyleBg>
      <Text fontSize="20px" bold mt="12px">
        {title}
      </Text>
      <Text fontSize="14px" mt="6px">
        <Trans
          i18nKey="GAME_6"
          values={{
            rate: winRate,
          }}
          components={{ number: <NumberText /> }}
        />
      </Text>
      <Flex mt="12px" alignItems="center">
        <Text fontSize="14px">
          <Trans
            i18nKey="GAME_7"
            values={{
              multiple: new BN(1).multipliedBy(multiple).toFixed(0, 1).toString(),
            }}
            components={{ number: <MultipleText /> }}
          />
          {/* Earn up to{' '}
          <span style={{ fontSize: '20px', fontWeight: 700, color: '#14D89D', marginRight: '3px', lineHeight: '18px' }}>
            ${new BN(1).multipliedBy(multiple).toFixed(0, 1).toString()}
          </span>{' '}
          on $1 */}
        </Text>
        <StyledMultipleTag>{multiple}x</StyledMultipleTag>
      </Flex>
      {account ? (
        <Button width="100%" mt="15px" style={{ borderRadius: '32px' }} onClick={() => history.push(link)}>
          Visit
        </Button>
      ) : (
        <ConnectWalletButton width="100%" mt="15px" style={{ borderRadius: '32px' }} />
      )}
      {tooltipVisible && tooltip}
    </StyledGameCard>
  )
}

export default GameCard
